import { render, staticRenderFns } from "./crsInfo.vue?vue&type=template&id=ef7ffb02"
import script from "./crsInfo.vue?vue&type=script&lang=js"
export * from "./crsInfo.vue?vue&type=script&lang=js"
import style0 from "./crsInfo.vue?vue&type=style&index=0&id=ef7ffb02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports